<div class="col">
    <div class="card h100">
        <div class="card-body">
            <div class="card-title">{{title}}</div>
            <div class="example-wrapper">
                <ng-container *ngTemplateOutlet="template"></ng-container>
            </div>
        </div>
    </div>
</div>